<template>
	<v-container style="background-color: #ffffff">
		<v-col cols="12">
			<SelfAssessment />
		</v-col>
		<v-col cols="12">
			<h3 class="timelinetitle">Overview of your suppliers ESG score over time and displayedon category</h3>
			<ESGscoretimeline />
		</v-col>
	</v-container>
</template>

<script>
import SelfAssessment from "../components/SelfAssesment.vue"
import ESGscoretimeline from "../components/ESGscoretimeline.vue"


export default {
	components: {
		SelfAssessment,
		ESGscoretimeline,
	},
}
</script>